import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { Application } from 'src/app/account/services/application.service'
import { BucketBackfillFailedIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { ApiService } from 'src/app/services/api.service'
import { SyncPairIssueScopeDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { ViewableIssue } from '../../issues-view/issues-view.component'

@Component({
  selector: 'bucket-backfill-failed-issue',
  templateUrl: './bucket-backfill-failed-issue.component.html',
  styleUrls: ['./bucket-backfill-failed-issue.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BucketBackfillFailedIssueComponent implements OnInit {
  @Input() issue: ViewableIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null

  private ackSubscription: Subscription = null

  constructor(
    public uiService: UiService,
    public apiService: ApiService
  ) {}

  ngOnInit(): void {}

  get backfillFailedIssue() {
    return this.issue.issue as BucketBackfillFailedIssue
  }

  get failedLogFiles() {
    return this.backfillFailedIssue.failedBucketReports
  }

  get failedPercentage() {
    const failedCopies = this.backfillFailedIssue.failedCopies
    const totalCopies = this.backfillFailedIssue.totalCopies
    if (!totalCopies) return '0.00' // avoid division by zero
    const percentage = (failedCopies / totalCopies) * 100
    return percentage.toFixed(2)
  }

  acknowledgeIssue() {
    this.ackSubscription = this.issue
      .deleter$()
      .pipe(finalize(() => (this.ackSubscription = null)))
      .subscribe(
        (_response) => {},
        (err) => {
          handleArpioError(window.location.href, this.apiService, this.uiService)(err)
        }
      )
  }
}
